"use client";

import dynamic from "next/dynamic";

export const ShopsMapClient = dynamic(
  async () => import("@/src/app/ou-trouver-les-produits/ShopsMap"),
  { ssr: false },
);
